import React, { useState } from "react";
import CustomButton from "./customButton";
import { Col, Row, Spin, message, Steps } from "antd";
import { IoIosArrowForward } from "react-icons/io";
import axios from "axios";
import { baseUrl } from "../utills";
import { green } from "../constants/colors";
import { useCarInfo } from "../context/CarInfoContext";
import styled from "styled-components";
import CustomBackButton from "./customBackButton";

const StyledSteps = styled(Steps)`
  &.site-navigation-steps {
    border-bottom: 1px solid lightgray;
    padding-top: 25px;
    padding-bottom: 8px;

    .ant-steps-item {
      .ant-steps-item-title {
        color: rgba(0, 0, 0, 0.85);
        font-size: 16px;
        font-weight: 500;
      }

      &.ant-steps-item-active {
        .ant-steps-item-title {
          color: ${green};
        }

        .ant-steps-item-icon {
          background-color: ${green};
          border-color: ${green};
        }
      }

      &.ant-steps-item-finish {
        .ant-steps-item-title {
          color: ${green};
        }

        .ant-steps-item-icon {
          border-color: ${green};
          background-color: ${green};

          .ant-steps-icon {
            color: #fff;
          }
        }
      }
    }
    .ant-steps-item::before {
      background-color: transparent !important;
    }
  }
    @media (max-width: 767px) {
    display: none !important;
  }
`;
const CarInfo = ({ setCarInfoModal }) => {
  const token = localStorage.getItem("access_token");
  const [carMake, setCarMake] = useState([]);
  const [selectedYear, setSelectedYear] = useState(null);
  const [selectedId, setSelectedId] = useState(null);
  const [selectedId2, setSelectedId2] = useState(null);
  const [selectedId3, setSelectedId3] = useState(null);
  const [carInfo, setCarInfo] = useCarInfo();
  const [carModels, setCarModels] = useState([]);
  const [version, setVersion] = useState([]);
  const [loading, setLoading] = useState({
    make: false,
    model: false,
    version: false,
  });
  const [messageApi, contextHolder] = message.useMessage();
  const [current, setCurrent] = useState(0);
const [customId, setCustomId]=useState(1);
  const fetchMake = async (year) => {
    setCarInfo((prevInfo) => ({
      ...prevInfo,
      year,
    }));
    setCustomId(2)
    setSelectedYear(year);
    if (year) {
      setLoading((prevState) => ({
        ...prevState,
        make: true,
      }));

      try {
        const res = await axios.get(
          baseUrl + `car_makers_by_year/?manufacture_year=${year}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (res?.status === 200) {
          setCurrent(1);
          setLoading((prevState) => ({
            ...prevState,
            make: false,
          }));
          setCarMake(res?.data?.data?.car_makers || []);
          setCarModels([]);
          setVersion([]);
        }
        // console.log("CarMake:", res);
      } catch (error) {
        console.error("error:", error);
        setLoading((prevState) => ({
          ...prevState,
          make: false,
        }));
        messageApi.open({
          type: "error",
          content: `No data available for the selected year: ${year}. Please try another year.`,
        });
        setCarMake([]);
      }
    }
  };

  const fetchModel = async (item) => {
    setCarInfo((prevInfo) => ({
      ...prevInfo,
      make: item?.car_maker,
      car_maker_id: item?.id,
    }));
    setSelectedId(item?.id);
    setCustomId(3)
    try {
      setLoading((prevState) => ({
        ...prevState,
        model: true,
      }));
      const res = await axios.get(
        baseUrl + `car_models/?car_maker_id=${item?.id}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if(res.status===200){
        setCarModels(res?.data?.car_models || []);
        setCurrent(2);
        setLoading((prevState) => ({
          ...prevState,
          model: false,
        }));
      }
     
    } catch (error) {
      console.error("error:", error);
      setLoading((prevState) => ({
        ...prevState,
        model: false,
      }));
    }
  };
  const fetchVersion = async (item, id, id2) => {
    setCarInfo((prevInfo) => ({
      ...prevInfo,
      model: item?.model_name,
      car_model_id: item.id,
    }));
    console.log("item:::::", item);
    setSelectedId2(id2);
    setCustomId(4)

    try {
      setLoading((prevState) => ({
        ...prevState,
        version: true,
      }));
      const res = await axios.get(
        baseUrl + `car_versions/${item?.car_maker_id}?model_id=${id2}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
     
      if (res.status === 200) {
        setCurrent(3);
        setVersion(res?.data || []);
        setLoading((prevState) => ({
          ...prevState,
          version: false,
        }));
      } else {
        setLoading((prevState) => ({
          ...prevState,
          version: false,
        }));
        setVersion([]);
      console.log("error:::", res);
      }
    } catch (error) {
      console.error("error:", error);
      // messageApi.open({
      //   type: "error",
      //   content: error?.response?.data?.detail,
      // });
      setVersion([]);
      setLoading((prevState) => ({
        ...prevState,
        version: false,
      }));
    }
  };
  const selectVersion = async (item) => {
    setCustomId(1)

    setCarInfo((prevInfo) => ({
      ...prevInfo,
      version: item,
      car_version_id: item?.id,
    }));
    setSelectedId3(item?.id);
    // setCarMake([]);
    // setCarModels([]);
    // setVersion([]);
    setCarInfoModal(false);
  };

  const submit = async () => {
    setCustomId(1)
    // setCarMake([]);
    // setCarModels([]);
    // setVersion([]);
    // setSelectedYear(null);
    // setSelectedId(null);
    // setSelectedId2(null);
    // setSelectedId3(null);
    setCarInfoModal(false);
  };
  const startYear = 2025;
  const endYear = 1940;
  const years = [];

  for (let year = startYear; year >= endYear; year--) {
    years.push(year);
  }

  const onChange = (value) => {
    console.log("onChange:", value);
    setCurrent(value);
  };
  console.log("version..",version);
  
  return (
    <>
      {contextHolder}
      <div className="md:hidden ms-2 pt-2">
      <CustomBackButton 
      onClick={() => {
        if (customId === 1) {
          setCarInfoModal(false);
        } else {
          setCustomId(customId - 1);  // Ensure customId is updated properly
        }
      }}
      />
      </div>
      <div className="">
        <StyledSteps
          type="navigation"
          size="small"
          current={current}
          onChange={onChange}
          className="site-navigation-steps"
          items={[
            {
              title: "MODEL YEAR",
              status: "",
              // description: "Get make.",
            },
            {
              title: "MAKE",
              status: "",
              // description: "Get model.",
            },
            {
              title: "MODEL",
              status: "",
              // description: "Get version.",
            },
            {
              title: "VERSION(optional)",
              status: "",
              // description: "",
            },
          ]}
        />

        {/* ============== */}
        {/* <div className="grid grid-cols-4">
          <div>
            <p className="text-[14px] md:text-[18px] font-[500] ps-2 md:ps-4 border-r border-b border-[#e0e0e0] py-4">
              MODEL YEAR
            </p>
          </div>
          <div>
            <p className="text-[14px] md:text-[18px] font-[500] ps-2 md:ps-4 border-b border-r border-[#e0e0e0] py-4">
              MAKE
            </p>
          </div>
          <div>
            <p className="text-[14px] md:text-[18px] font-[500] ps-2 md:ps-4 border-r border-b border-[#e0e0e0] py-4">
              MODEL
            </p>
          </div>
          <div>
            <p className="text-[14px] md:text-[18px] font-[500] ps-2 md:ps-4 border-b border-[#e0e0e0] py-[5px] md:py-4">
              VERSION{" "}
              <span className="text-[14px] md:text-[16px] font-[400]">
                (OPTIONAL)
              </span>
            </p>
          </div>
        </div> */}
      </div>
      <div className="hidden md:grid grid-cols-4">
        <div>
          <div className="py-4 border-[#e0e0e0] border-r border-b px-2">
            <div className="overflow overflow-y-auto h-[400px] px-2">
              {years?.map((year) => (
                <div
                  key={year}
                  onClick={() => fetchMake(year)}
                  className={`flex justify-between items-center mt-2 cursor-pointer hover:text-customGreen ${
                    selectedYear === year ? "text-customGreen" : ""
                  }`}
                >
                  <p className="font-[400]">{year}</p>
                  <IoIosArrowForward />
                </div>
              ))}
            </div>
          </div>
        </div>
        <div>
        <Spin spinning={loading.make} className="custom-spin">
            <div
              className={`py-4 border-r border-b px-2 ${
                carMake?.length < 1
                  ? "bg-gray-200 cursor-not-allowed opacity-50 border-gray-400"
                  : "border-[#e0e0e0]"
              }`}
            >
              <div className="overflow overflow-y-auto h-[400px] px-2">
                {carMake?.map((item, id) => (
                  <div
                    key={item?.id}
                    onClick={() => fetchModel(item)}
                    className={`flex justify-between items-center mt-2 cursor-pointer hover:text-customGreen ${
                      selectedId === item?.id ? "text-customGreen" : ""
                    }`}
                  >
                    <p className="font-[400]">{item?.car_maker}</p>
                    <IoIosArrowForward />
                  </div>
                ))}
              </div>
            </div>
          </Spin>
        </div>
        <div>
        <Spin spinning={loading.model} className="custom-spin">
          <div
            className={`py-4 border-r border-b px-2 ${
              carModels?.length < 1
                ? "bg-gray-200 cursor-not-allowed opacity-50 border-gray-400"
                : "border-[#e0e0e0]"
            }`}
          >
            <div className="overflow overflow-y-auto h-[400px] px-2">
              {carModels?.map((item) => (
                <div
                  key={item?.id}
                  onClick={() =>
                    fetchVersion(item, item?.car_maker_id, item?.id)
                  }
                  className={`flex justify-between items-center mt-2 cursor-pointer hover:text-customGreen ${
                    selectedId2 === item?.id ? "text-customGreen" : ""
                  }`}
                >
                  <p className="font-[400]">{item?.model_name}</p>
                  <IoIosArrowForward />
                </div>
              ))}
            </div>
          </div>
          </Spin>
        </div>
        <div>
        <Spin spinning={loading.version} className="custom-spin">
          <div
            className={`py-4 px-2 border-r border-b ${
              version?.length < 1
                ? "bg-gray-200 cursor-not-allowed opacity-50  border-gray-400"
                : "border-[#e0e0e0]"
            }`}
          >
            <div className="overflow overflow-y-auto h-[400px] px-2">
              {version?.length > 0 ? (
                version?.map((item) => (
                  <div
                    key={item?.id}
                    onClick={() => selectVersion(item)}
                    className={`mt-2   mb-6
                
                `}
                  >
                    <div className="flex gap-4 font-[500] mb-2 text-[16px]">
                      <p className="">{item?.manufacture_start_year}</p>
                      <p className="">{item?.manufacture_end_year}</p>
                    </div>
                    <div className={`hover cursor-pointer hover:text-customGreen
                      ${selectedId3 === item?.id ? "text-customGreen" : ""}`} >
                    <p className="font-[500] text-[16px]">
                      {item?.version_name} {item?.transmission}
                    </p>

                    <p
                      className={`text-[14px]`}
                    >
                      {item?.engine_cc}cc/{item?.fuel_type}
                    </p>
                    </div>
                  </div>
                ))
              ) : (
                <div className="flex justify-center items-center h-full text-center">
                  <div>
                  {/* <p className="text-[18px] font-[500] mb-4">Version not found.</p> */}
                  {/* <p> <strong>No worries,</strong> it's optional just click the below  <strong>Done</strong> button.</p> */}
                  </div>
                </div>
              )}
            </div>
          </div>
          </Spin>
        </div>
      </div>

      <div className="md:hidden">
        {customId===1?
        <div>
          <div className="py-4 border-[#e0e0e0] border-r border-b px-2">
            <p>Model Year</p>
            <div className="overflow overflow-y-auto h-[400px] px-2">
              {years?.map((year) => (
                <div
                  key={year}
                  onClick={() => fetchMake(year)}
                  className={`flex justify-between items-center mt-2 cursor-pointer hover:text-customGreen ${
                    selectedYear === year ? "text-customGreen" : ""
                  }`}
                >
                  <p className="font-[400]">{year}</p>
                  <IoIosArrowForward />
                </div>
              ))}
            </div>
          </div>
        </div>
        :customId===2?
        <div>
          <Spin spinning={loading.make} className="custom-spin">
            <div
              className={`py-4 border-r border-b px-2 ${
                carMake?.length < 1
                  ? "bg-gray-200 cursor-not-allowed opacity-50 border-gray-400"
                  : "border-[#e0e0e0]"
              }`}
            >
            <p>MAKE</p>

              <div className="overflow overflow-y-auto h-[400px] px-2">
                {carMake?.map((item, id) => (
                  <div
                    key={item?.id}
                    onClick={() => fetchModel(item)}
                    className={`flex justify-between items-center mt-2 cursor-pointer hover:text-customGreen ${
                      selectedId === item?.id ? "text-customGreen" : ""
                    }`}
                  >
                    <p className="font-[400]">{item?.car_maker}</p>
                    <IoIosArrowForward />
                  </div>
                ))}
              </div>
            </div>
          </Spin>
        </div>
        :customId===3?
        <div>
          <Spin spinning={loading.model} className="custom-spin">
          <div
            className={`py-4 border-r border-b px-2 ${
              carModels?.length < 1
                ? "bg-gray-200 cursor-not-allowed opacity-50 border-gray-400"
                : "border-[#e0e0e0]"
            }`}
          >
            <p>Model</p>
            <div className="overflow overflow-y-auto h-[400px] px-2">
              {carModels?.map((item) => (
                <div
                  key={item?.id}
                  onClick={() =>
                    fetchVersion(item, item?.car_maker_id, item?.id)
                  }
                  className={`flex justify-between items-center mt-2 cursor-pointer hover:text-customGreen ${
                    selectedId2 === item?.id ? "text-customGreen" : ""
                  }`}
                >
                  <p className="font-[400]">{item?.model_name}</p>
                  <IoIosArrowForward />
                </div>
              ))}
            </div>
          </div>
          </Spin>
        </div>
        :
        <div>
          <Spin spinning={loading.version} className="custom-spin">
          <div
            className={`py-4 px-2 border-r border-b ${
              version?.length < 1
                ? "bg-gray-200 cursor-not-allowed opacity-50  border-gray-400"
                : "border-[#e0e0e0]"
            }`}
          >
            <p>Version(Optional)</p>
            <div className="overflow overflow-y-auto h-[400px] px-2">
              {version?.length > 0 ? (
                version?.map((item) => (
                  <div
                    key={item?.id}
                    onClick={() => selectVersion(item)}
                    className={`mt-2   mb-6
                
                `}
                  >
                    <div className="flex gap-4 font-[500] mb-2 text-[16px]">
                      <p className="">{item?.manufacture_start_year}</p>
                      <p className="">{item?.manufacture_end_year}</p>
                    </div>

                    <div className={`hover cursor-pointer hover:text-customGreen
                      ${selectedId3 === item?.id ? "text-customGreen" : ""}`} >

                    <p className="font-[500] text-[16px]">
                      {item?.version_name} {item?.transmission}
                    </p>

                    <p
                      className={`text-[14px]`}
                    >
                      {item?.engine_cc}cc/{item?.fuel_type}
                    </p>
                  </div>
                  </div>

                ))
              ) : (
                <div className="flex justify-center items-center h-full text-center">
                <div>
                {/* <p className="text-[18px] font-[500] mb-4">Version not found.</p> */}
                {/* <p> <strong>No worries,</strong> it's optional just click the below  <strong>Done</strong> button.</p> */}
                </div>
              </div>
              )}
            </div>
          </div>
          </Spin>
        </div>
}
      </div>
      <div className="mt-4 mb-4">
        <CustomButton
          style={{
            background: green,
            borderRadius: "4px",
            padding: "0px",
            width: "70px",
            margin: "auto",
          }}
          onClick={submit}
        >
          Done
        </CustomButton>
      </div>
    </>
  );
};

export default CarInfo;
